import { InjectionToken } from '@angular/core';

export interface TableConfig {
  paginable?: boolean;
  scrollable?: boolean;
  selectable?: boolean;
  sortable?: boolean;
}

export const DEFAULT_CONFIG: TableConfig = {
  scrollable: false,
  selectable: false,
  paginable: false,
  sortable: false,
};

export const AZ_TABLE_CONFIG = new InjectionToken<TableConfig>('AZ_TABLE_CONFIG');
